








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import LeftTimer from "@/components//JinroPlayer/LeftTimer.vue";
@Component({
  components: {
    LeftTimer
  }
})
export default class Day extends Vue {
  @Prop() readonly jinroPlayinfo!: any;

  get nDay(): string {
    return this.jinroPlayinfo.dayN;
  }
}
